import { ASSET_SIZE_STATUS } from '~/config/constants/asset'
import { isCrossingTransition } from './isCrossingTransition'

export function getTwoSideTransitionInsertStatus(assets, leftAsset,
  rightAsset, transition, transitionDuration) {
  if (!transition) return null
  const rightExpandDuration = rightAsset?.mediaStart
  const leftExpandDuration = leftAsset?.mediaFileDuration
    - leftAsset?.duration - leftAsset?.mediaStart

  const existsFadeOutDuration = assets
    .find(a => (a.isMountOut || isCrossingTransition(a.type))
      && a.leftVideoAssetId === rightAsset?.id)?.duration ?? 0
  const existsFadeInDuration = assets
    .find(a => (a.isMountIn || isCrossingTransition(a.type))
      && a.rightVideoAssetId === leftAsset?.id)?.duration ?? 0

  if (leftExpandDuration >= (transitionDuration / 2)
      && rightExpandDuration >= (transitionDuration / 2)
      && rightAsset?.startTime - (transitionDuration / 2)
      >= leftAsset?.startTime + existsFadeInDuration
      && leftAsset?.endTime + (transitionDuration / 2)
      <= rightAsset?.endTime - existsFadeOutDuration) {
    return ASSET_SIZE_STATUS.LEFT_CUT_RIGHT_CUT
  }

  if (rightExpandDuration >= leftAsset?.duration
      && leftAsset?.duration <= (transitionDuration / 2)
      && (leftAsset?.duration + leftExpandDuration) >= transitionDuration
      && leftAsset?.endTime + (transitionDuration - leftAsset?.duration)
      <= rightAsset?.endTime - existsFadeOutDuration) {
    return ASSET_SIZE_STATUS.LEFT_CUT_RIGHT_CUT_ASYMMETRICAL
  }

  if (rightExpandDuration >= transitionDuration
      && rightAsset?.startTime - transitionDuration
      >= leftAsset?.startTime + existsFadeInDuration
      && rightAsset.startTime - transitionDuration >= 0) {
    return ASSET_SIZE_STATUS.RIGHT_CUT_LEFT_NORMAL
  }

  if (leftExpandDuration >= transitionDuration
      && leftAsset?.endTime + transitionDuration
      <= rightAsset?.endTime - existsFadeOutDuration) {
    return ASSET_SIZE_STATUS.LEFT_CUT_RIGHT_NORMAL
  }

  if (leftAsset?.startTime + existsFadeInDuration
    <= rightAsset?.startTime - transitionDuration
    && rightAsset?.startTime - transitionDuration >= 0
    && leftAsset?.endTime <= rightAsset?.endTime - transitionDuration - existsFadeOutDuration) {
    return ASSET_SIZE_STATUS.NOT_CUT
  }

  return ASSET_SIZE_STATUS.OUTSIDE_BORDERS
}
